import * as actionTypes from "./productActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
import { toast } from 'react-toastify';
const { REACT_APP_API_URL } = process.env;

export const fetchProducts = (slug) => {
    return (dispatch) => {
        dispatch(fetchProductsInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/product/category/${slug}`))
        .then((response) => {
            dispatch(fetchProductsSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchProductsFailure());
            checkError(error);
        })
    };
};

export const fetchProductsInit = () => ({
    type: actionTypes.FETCH_PRODUCTS
});

export const fetchProductsFailure = () => ({
    type: actionTypes.FETCH_PRODUCTS_FAILURE
});

export const fetchProductsSuccess = data => ({
    type: actionTypes.FETCH_PRODUCTS_SUCCESS,
    payload: { data }
});

export const fetchWishlist = () => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem("userToken")}` } };
    return (dispatch) => {
        dispatch(fetchWishlistInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/wishlist`, config))
        .then((response) => {
            dispatch(fetchWishlistSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchWishlistFailure());
            checkError(error);
        })
    };
};

export const fetchWishlistInit = () => ({
    type: actionTypes.FETCH_WISHLIST
});

export const fetchWishlistFailure = () => ({
    type: actionTypes.FETCH_WISHLIST_FAILURE
});

export const fetchWishlistSuccess = data => ({
    type: actionTypes.FETCH_WISHLIST_SUCCESS,
    payload: { data }
});

export const addToWishlist = (data) => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem("userToken")}` } };
    return (dispatch) => {
        dispatch(addToWishlistInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/wishlist/store`, data, config))
        .then((response) => {
            toast.success("Added to wishlist.", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored"
            });
            dispatch(addToWishlistSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(addToWishlistFailure());
            checkError(error);
        })
    };
};

export const addToWishlistInit = () => ({
    type: actionTypes.ADD_TO_WISHLIST
});

export const addToWishlistFailure = () => ({
    type: actionTypes.ADD_TO_WISHLIST_FAILURE
});

export const addToWishlistSuccess = data => ({
    type: actionTypes.ADD_TO_WISHLIST_SUCCESS,
    payload: { data }
});

export const removeToWishlist = (id) => {
    const config = { headers: { Authorization: `Bearer ${sessionStorage.getItem("userToken")}` } };
    return (dispatch) => {
        dispatch(removeToWishlistInit());
        apiTimeout(axios.delete(`${REACT_APP_API_URL}/wishlist/${id}`, config))
        .then((response) => {
            toast.success("Removed from wishlist.", {
                position: toast.POSITION.TOP_RIGHT,
                theme: "colored"
            });
            dispatch(removeToWishlistSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(removeToWishlistFailure());
            checkError(error);
        })
    };
};

export const removeToWishlistInit = () => ({
    type: actionTypes.REMOVE_TO_WISHLIST
});

export const removeToWishlistFailure = () => ({
    type: actionTypes.REMOVE_TO_WISHLIST_FAILURE
});

export const removeToWishlistSuccess = data => ({
    type: actionTypes.REMOVE_TO_WISHLIST_SUCCESS,
    payload: { data }
});

export const fetchHomeProducts = () => {
    return (dispatch) => {
        dispatch(fetchHomeProductsInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/product/home`))
        .then((response) => {
            dispatch(fetchHomeProductsSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchHomeProductsFailure());
            checkError(error);
        })
    };
};

export const fetchHomeProductsInit = () => ({
    type: actionTypes.FETCH_HOME_PRODUCTS
});

export const fetchHomeProductsFailure = () => ({
    type: actionTypes.FETCH_HOME_PRODUCTS_FAILURE
});

export const fetchHomeProductsSuccess = data => ({
    type: actionTypes.FETCH_HOME_PRODUCTS_SUCCESS,
    payload: { data }
});

export const fetchProduct = (slug) => {
    return (dispatch) => {
        dispatch(fetchProductInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/product/${slug}`))
        .then((response) => {
            dispatch(fetchProductSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchProductFailure());
            checkError(error);
        })
    };
};

export const fetchProductInit = () => ({
    type: actionTypes.FETCH_PRODUCT
});

export const fetchProductFailure = () => ({
    type: actionTypes.FETCH_PRODUCT_FAILURE
});

export const fetchProductSuccess = data => ({
    type: actionTypes.FETCH_PRODUCT_SUCCESS,
    payload: { data }
});
